export type View = "fmsAdvisor" | "technician" | "teamLead" | "serviceManager";

export type ViewDefinition = {
    id: View;
    label: string;
};

export const viewDefinitions: Record<View, ViewDefinition> = {
    fmsAdvisor: {
        id: "fmsAdvisor",
        label: "FMS Advisor",
    },
    technician: {
        id: "technician",
        label: "Technician",
    },
    teamLead: {
        id: "teamLead",
        label: "Team Lead",
    },
    serviceManager: {
        id: "serviceManager",
        label: "Service Manager",
    },
};
